import React, { useState } from 'react'
import { string } from 'prop-types'
import { Button, DesignToken } from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import useIsomorphicLayoutEffect from '@/hooks/useIsomorphicLayoutEffect'
import { canUseWindow } from '@/utils/browser'

const buttonCss = css`
  font-size: 16px;
  width: max-content;
  background-color: var(${DesignToken.DecorRed500});
  border-color: var(${DesignToken.DecorRed500});
`

const SignUpButton = ({
  className,
  linkBase = `${process.env.GATSBY_ACCOUNTS_WEBSITE_URL}/signup/?source_id=marketplace&source_type=website`,
}) => {
  const [sourceUrl, setSourceUrl] = useState(
    `${process.env.GATSBY_PRODUCT_WEBSITE_URL}/marketplace/`
  )

  useIsomorphicLayoutEffect(() => {
    if (canUseWindow) {
      setSourceUrl(
        `${process.env.GATSBY_PRODUCT_WEBSITE_URL}${window.location.pathname}`
      )
    } else {
      setSourceUrl(`${process.env.GATSBY_PRODUCT_WEBSITE_URL}/marketplace/`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <a href={`${linkBase}&source_url=${sourceUrl}`}>
      <Button kind="destructive" css={buttonCss} className={className}>
        Sign up free
      </Button>
    </a>
  )
}

SignUpButton.propTypes = {
  className: string,
  linkBase: string,
}

export default SignUpButton
